// extracted by css-extract-rspack-plugin
var _1 = "gOdEyjYf39MkX2nG";
var _2 = "k4I7pJefFgI41tEF";
var _3 = "HOSQcN26qnEe4Gjp";
var _4 = "Z1SbRcv4ZkYNf5rf";
var _5 = "B4xHk_cKQ8wCyrC7";
export { _1 as "arrowStyle", _2 as "closeIconStyle", _3 as "outerWrapper", _4 as "popoverContentWrapperStyle", _5 as "popoverWrapperStyle" }
